module.exports = __webpack_public_path__ + "img/sms.0199ecd6.png";